import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { racineCountyConfig } from "./data";

export default function RacineCountyPage() {
  return <CityPageTemplate config={racineCountyConfig} />;
}